export default {
  title: 'Streams',
  description: 'Live streaming and broadcast management',
  create: 'Create Stream',
  goLive: 'Go Live',
  endStream: 'End Stream',
  stream: {
    title: 'Stream Title',
    description: 'Stream Description',
    status: 'Status',
    live: 'Live',
    offline: 'Offline',
    scheduled: 'Scheduled',
    ended: 'Ended',
    viewers: 'Viewers',
    duration: 'Duration',
    startTime: 'Start Time',
    endTime: 'End Time',
    streamKey: 'Stream Key',
    streamUrl: 'Stream URL'
  },
  settings: {
    title: 'Stream Settings',
    quality: 'Quality',
    resolution: 'Resolution',
    bitrate: 'Bitrate',
    frameRate: 'Frame Rate',
    audio: 'Audio Settings',
    video: 'Video Settings',
    privacy: 'Privacy',
    public: 'Public',
    private: 'Private',
    unlisted: 'Unlisted'
  },
  chat: {
    title: 'Live Chat',
    send: 'Send',
    moderator: 'Moderator',
    viewer: 'Viewer',
    disabled: 'Chat disabled'
  }
}